<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :items="data.form.historicosEnfermagem"
                    :validations="validations.historicoEnfermagem"
                    label="Queixa do paciente"
                    v-model="data.model.historicoEnfermagem"
                >
                    <template v-slot:row="{ item }">
                        <rkm-row>
                            <rkm-col cols="4">
                                <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                <div>{{ item.lotacao.profissional.nome }}</div>
                                <div>{{ item.dataHora }}</div>
                            </rkm-col>

                            <rkm-col>
                                {{ item.descricao }}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-form-incremental-textarea>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :items="data.form.outrasAvaliacoesCondicoes"
                    :validations="validations.outrasAvaliacoesCondicoes"
                    label="Outras avaliações e condições"
                    v-model="data.model.outrasAvaliacoesCondicoes"
                >
                    <template v-slot:row="{ item }">
                        <rkm-row>
                            <rkm-col cols="4">
                                <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                <div>{{ item.lotacao.profissional.nome }}</div>
                                <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                <div>{{ item.dataHora }}</div>
                            </rkm-col>

                            <rkm-col>
                                {{ item.descricao }}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-form-incremental-textarea>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-incremental-textarea
                    :items="data.form.observacoes"
                    :validations="validations.observacoes"
                    label="Observações"
                    v-model="data.model.observacoes"
                >
                    <template v-slot:row="{ item }">
                        <rkm-row>
                            <rkm-col cols="4">
                                <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                <div>{{ item.lotacao.profissional.nome }}</div>
                                <div>{{ item.dataHora }}</div>
                            </rkm-col>

                            <rkm-col>
                                {{ item.descricao }}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-form-incremental-textarea>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

export default {
    components: { RkmFormIncrementalTextarea },
    computed: {
        validations() {
            return {
                historicoEnfermagem: { max: 3000 },
                observacoes: { max: 3000 },
                outrasAvaliacoesCondicoes: { max: 3000 },
            }
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>